import { render, staticRenderFns } from "./CallbackSettings.vue?vue&type=template&id=67459c21&scoped=true"
import script from "./CallbackSettings.vue?vue&type=script&lang=js"
export * from "./CallbackSettings.vue?vue&type=script&lang=js"
import style0 from "./CallbackSettings.vue?vue&type=style&index=0&id=67459c21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67459c21",
  null
  
)

export default component.exports